import request from '@/service/lib/request'

/**
 * 测报灯 - 获取图片列表
 * @param {String} url 请求地址
 * @param {Object} params 请求参数
 */
export function getPictures(companyId, params) {
  return request({
    url: `/api/v1/companies/${companyId}/pictures`,
    method: 'get',
    params
  })
}

export function getDetail(id, params) {
  return request({
    url: `/api/v1/pictures/${id}`,
    method: 'get',
    params
  })
}

/**
 * 测报灯 - 获取图片详情
 * @param {String} url 请求地址
 * @param {Object} params 请求参数
 */
export function getInfo(id, params) {
  return request({
    url: `/api/v1/pictures/${id}`,
    method: 'get',
    params
  })
}

/**
 * 测报灯 - 获取预警历史
 * @param {String} url 请求地址
 * @param {Object} params 请求参数
 */
export function getReport(companyId, params) {
  return request({
    url: `/api/v1/companies/${companyId}/reports`,
    method: 'get',
    params
  })
}

/**
 * 测报灯 - 获取当前预警数据
 * @param {String} url 请求地址
 * @param {Object} params 请求参数
 */
export function getWarnings(companyId, params) {
  return request({
    url: `/api/v1/companies/${companyId}/dashboard`,
    method: 'get',
    params
  })
}

/**
 * 测报灯 - 更新图片识别
 * @param {String} url 请求地址
 * @param {Object} params 请求参数
 */
export function updateReview(id, data) {
  return request({
    url: `/api/v1/pictures/${id}/review`,
    method: 'put',
    data
  })
}

/**
 * 测报灯 - 获取当前预警数据
 * @param {String} url 请求地址
 * @param {Object} params 请求参数
 */
export function getTrend(id) {
  return request({
    url: `/api/v1/devices/${id}/trends`,
    method: 'get'
  })
}

/**
 * 测报灯 - 按月份查询每天薯片数量
 * @param {String} deviceId 设备id
 * @param {Object} month 月份
 */
export function getDateCount(deviceId, month, companyId) {
  return request({
    url: `/api/v1/pictures/date-count`,
    method: 'get',
    params: { deviceId, month, companyId }
  })
}

/**
 * 测报灯 - 远程拍照
 * @param {String} deviceId 设备id
 */
export function take(deviceId) {
  return request({
    url: `/api/v1/devices/${deviceId}/take-photo`,
    method: 'get'
  })
}

/**
 * 测报灯 - 获取图片列表
 * @param {String} url 请求地址
 * @param {Object} params 请求参数
 */
export function getImgsV2(params) {
  return request({
    url: `/api/v2/pictures`,
    method: 'get',
    params
  })
}
